import React from 'react';
import { classNames } from '../../utils/format';

export default function IconButton({ className, ariaLabel, children, ...rest }) {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      className={classNames('icon-btn', className)}
      {...rest}
    >
      {children}
    </button>
  );
}
